export default {"src":"https://cdn.jetlend.ru/_next/static/media/arrow-green-bottom.2d0e8d65.svg","height":10,"width":15,"blurWidth":0,"blurHeight":0};